/**
 * Number parsing utilities
 * Pure functions for parsing strings to numbers
 */

/**
 * Parse string to integer
 * @param value - String to parse
 * @returns Parsed integer or undefined if invalid
 * @example parseNumber("123") => 123
 */
export function parseNumber(value: string | null | undefined): number | undefined {
    if (!value) return undefined;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? undefined : parsed;
}

/**
 * Parse string to float
 * @param value - String to parse
 * @returns Parsed float or undefined if invalid
 * @example parseFloat("123.45") => 123.45
 */
export function parseFloat(value: string | null): number | undefined {
    if (!value) return undefined;
    const parsed = Number.parseFloat(value);
    return isNaN(parsed) ? undefined : parsed;
}
